export default __webpack_public_path__ + "static/media/musical-notes.e3c951a3.svg";